import cn from 'classnames';
import { useIntl } from 'react-intl';
import { Input } from 'sonata-react-components';

import { useLineItemFormContext } from '@/components/liSettings/LineItemForm/LineItemForm.provider';
import { useGlobalStore } from '@/store/global';
import { getBaseCurrency } from '@/store/global/baseCurrency/selectors';
import { useStore as useLineItemStore } from '@/store/local/lineItem';

import type { LineItemStore } from '@/store/local/lineItem';

type Props = {
  className?: string;
  goalTimeFrame: 'overall' | 'daily';
};

export function GoalBudget({ className, goalTimeFrame }: Props) {
  const { formatMessage } = useIntl();

  const state = useLineItemStore() as LineItemStore;
  const { setGoal: setFormGoal } = useLineItemFormContext();

  const { goals, setGoal } = state;
  const goal = goals?.find(({ timeFrame, type }) => timeFrame === goalTimeFrame && type === 'budget');
  const baseCurrency = useGlobalStore(getBaseCurrency);

  const handleBudgetChange = (newValue: string | FileList | null) => {
    let target: number | null = parseFloat(newValue as string);
    if (isNaN(target) || target < 0 || !target) {
      target = null;
    }
    setFormGoal({
      target,
      timeFrame: goalTimeFrame,
      type: 'budget'
    });
    setGoal({
      target,
      timeFrame: goalTimeFrame,
      type: 'budget'
    });
  };

  const classNames = cn({
    dailyBudget__inputWithSymbol: goalTimeFrame === 'daily',
    overallBudget__inputWithSymbol: goalTimeFrame === 'overall'
  });

  return (
    <div className={className}>
      <Input
        autofocus={false}
        className={classNames}
        currencyConfig={baseCurrency}
        defaultValue={goal && goal.target ? goal.target : undefined}
        id={`${goalTimeFrame}BudgetCurrencyInput`}
        inputAdditionalProps={{
          min: 0
        }}
        label={
          goalTimeFrame === 'overall'
            ? formatMessage({
                defaultMessage: 'Budget',
                id: 'budgetGoals.overallBudget.title'
              })
            : formatMessage({
                defaultMessage: 'Daily budget (per day)',
                id: 'budgetGoals.dailyBudget.inputLabel'
              })
        }
        name="overallBudgetInput"
        numberFormat="currency"
        numberOfDecimals={2}
        onChange={handleBudgetChange}
        placeholder={formatMessage({
          defaultMessage: 'Unlimited',
          id: 'budgetGoals.currencyInputPlaceholder'
        })}
        shape="squareUI"
        type="number"
      />
    </div>
  );
}
